import {
  theme_default
} from "./chunk-M7FL4KKM.esm.js";

// src/providers/StockXGoldTheme.tsx
import {
  ChakraProvider,
  localStorageManager
} from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var StockXGoldTheme = ({
  children,
  theme = theme_default,
  resetCSS = true,
  colorModeManager = localStorageManager,
  ...props
}) => /* @__PURE__ */ jsx(
  ChakraProvider,
  {
    theme,
    resetCSS,
    colorModeManager,
    ...props,
    children
  }
);
var StockXGoldTheme_default = StockXGoldTheme;

export {
  StockXGoldTheme_default
};
